/*
 * Clovie: Native Produkt-Empfehlungen im Warenkorb (Ersatz fuer UpCart)
 * Querformat-Karten (Bild links), Auto-Scroll + Pfeile, direkt unter den Artikeln.
 */
(function () {
  'use strict';

  var EXCLUDE_PRODUCT_IDS = [9393296834902]; // Clovie Garantie nicht empfehlen
  var FETCH_LIMIT = 10;
  var MAX_CARDS = 6;
  var AUTOPLAY_MS = 3500;
  var TITLE = 'Das könnte dir auch gefallen';
  var SVG_PREV = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  var cache = { key: null, products: null };
  var autoTimer = null;

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function imgUrl(p) {
    var u = p.featured_image || (p.images && p.images[0]) || '';
    if (typeof u !== 'string') u = '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function fetchRecs(pid) {
    if (cache.key === pid && cache.products) return Promise.resolve(cache.products);
    var url = '/recommendations/products.json?product_id=' + pid + '&limit=' + FETCH_LIMIT + '&intent=related';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        cache.key = pid; cache.products = list;
        return list;
      });
  }

  function drawer() { return document.querySelector('.js-cart-drawer'); }

  function availableVariants(product) {
    return (product.variants || []).filter(function (v) { return v.available !== false; });
  }

  function priceHtml(price, compare) {
    var h = '<span class="clovie-rec__price">' + euro(price) + '</span>';
    if (compare && compare > price) h += '<span class="clovie-rec__compare">' + euro(compare) + '</span>';
    return h;
  }

  function buildCard(product) {
    var avail = availableVariants(product);
    if (!avail.length) return null;
    var first = avail[0];

    var optionsHtml = '';
    if (avail.length > 1) {
      optionsHtml = '<select class="clovie-rec__select" aria-label="Variante wählen">';
      for (var i = 0; i < avail.length; i++) {
        var v = avail[i];
        optionsHtml += '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">'
          + esc(v.title || v.name) + '</option>';
      }
      optionsHtml += '</select>';
    }

    var card = document.createElement('div');
    card.className = 'clovie-rec';
    card.innerHTML =
      '<a class="clovie-rec__img" href="' + esc(product.url) + '" style="background-image:url(' + esc(imgUrl(product)) + ')" aria-label="' + esc(product.title) + '"></a>'
      + '<div class="clovie-rec__info">'
      + '<a class="clovie-rec__title" href="' + esc(product.url) + '">' + esc(product.title) + '</a>'
      + '<div class="clovie-rec__pricewrap">' + priceHtml(first.price, first.compare_at_price) + '</div>'
      + '<div class="clovie-rec__controls">'
      + optionsHtml
      + '<button type="button" class="clovie-rec__add" data-variant="' + first.id + '">Hinzufügen</button>'
      + '</div>'
      + '</div>';

    var sel = card.querySelector('.clovie-rec__select');
    var btn = card.querySelector('.clovie-rec__add');
    var pw = card.querySelector('.clovie-rec__pricewrap');

    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        btn.setAttribute('data-variant', o.value);
        pw.innerHTML = priceHtml(parseInt(o.getAttribute('data-price'), 10), parseInt(o.getAttribute('data-compare'), 10));
      });
    }
    btn.addEventListener('click', function () { addToCart(btn); });
    return card;
  }

  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '✓ Im Warenkorb';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1400);
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  function setupCarousel(block, row) {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    var prev = block.querySelector('.clovie-recs__nav--prev');
    var next = block.querySelector('.clovie-recs__nav--next');
    var multi = row.children.length > 1;
    if (!multi) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }
    var paused = false;

    function step(dir) {
      var first = row.children[0];
      if (!first) return;
      var w = first.getBoundingClientRect().width + 10;
      var maxScroll = row.scrollWidth - row.clientWidth;
      var target = row.scrollLeft + dir * w;
      if (target > maxScroll + 2) target = 0;
      else if (target < -2) target = maxScroll;
      row.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { paused = true; step(-1); });
    if (next) next.addEventListener('click', function () { paused = true; step(1); });
    row.addEventListener('mouseenter', function () { paused = true; });
    row.addEventListener('mouseleave', function () { paused = false; });
    row.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    row.addEventListener('focusin', function () { paused = true; });

    var idx = 0;
    autoTimer = setInterval(function () {
      if (paused || !row.isConnected) return;
      idx = (idx + 1) % row.children.length;
      var base = row.children[0].offsetLeft;
      row.scrollTo({ left: row.children[idx].offsetLeft - base, behavior: 'smooth' });
    }, AUTOPLAY_MS);
  }

  function render() {
    var d = drawer();
    if (!d) return;
    var content = d.querySelector('.cart-drawer__content');
    if (!content) return;
    var mount = d.querySelector('.cart-drawer__content-upper') || content;

    getCart().then(function (cart) {
      var existing = content.querySelector('.clovie-recs');
      if (!cart || !cart.items || cart.item_count === 0) {
        if (existing) existing.remove();
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
        return;
      }

      var pid = cart.items[0].product_id;
      var cartProductIds = cart.items.map(function (i) { return i.product_id; });

      fetchRecs(pid).then(function (products) {
        var pool = products.filter(function (p) {
          return EXCLUDE_PRODUCT_IDS.indexOf(p.id) === -1 && cartProductIds.indexOf(p.id) === -1;
        });

        var old = content.querySelector('.clovie-recs');
        if (old) old.remove();
        if (!pool.length) return;

        var block = document.createElement('div');
        block.className = 'clovie-recs';
        block.innerHTML = '<div class="clovie-recs__title">' + esc(TITLE) + '</div>'
          + '<div class="clovie-recs__viewport">'
          + '<button type="button" class="clovie-recs__nav clovie-recs__nav--prev" aria-label="Zurück">' + SVG_PREV + '</button>'
          + '<div class="clovie-recs__row"></div>'
          + '<button type="button" class="clovie-recs__nav clovie-recs__nav--next" aria-label="Weiter">' + SVG_NEXT + '</button>'
          + '</div>';
        var row = block.querySelector('.clovie-recs__row');

        var count = 0;
        for (var i = 0; i < pool.length && count < MAX_CARDS; i++) {
          var card = buildCard(pool[i]);
          if (card) { row.appendChild(card); count++; }
        }
        if (count === 0) return;
        mount.appendChild(block);
        setupCarousel(block, row);
      });
    }).catch(function () {});
  }

  function injectCss() {
    if (document.getElementById('clovie-recs-css')) return;
    var css =
      '.clovie-recs{margin-top:12px;padding-top:10px;border-top:1px solid #ececec}'
      + '.clovie-recs__title{font-size:.8rem;font-weight:700;color:#1a1a1a;margin:0 0 8px 10px}'
      + '.clovie-recs__viewport{position:relative}'
      + '.clovie-recs__row{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:0 10px 4px;scrollbar-width:none}'
      + '.clovie-recs__row::-webkit-scrollbar{display:none}'
      + '.clovie-recs__nav{position:absolute;top:42%;transform:translateY(-50%);z-index:3;width:26px;height:26px;border-radius:50%;border:1px solid #e2e2e2;background:rgba(255,255,255,.95);color:#1a1a1a;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;box-shadow:0 1px 4px rgba(0,0,0,.14)}'
      + '.clovie-recs__nav--prev{left:2px}'
      + '.clovie-recs__nav--next{right:2px}'
      + '.clovie-recs__nav:active{transform:translateY(-50%) scale(.92)}'
      + '.clovie-rec{flex:0 0 100%;scroll-snap-align:start;display:flex;flex-direction:row;align-items:center;gap:12px;border:1px solid #eee;border-radius:10px;padding:8px 12px;background:#fff;box-sizing:border-box}'
      + '.clovie-rec__img{flex:0 0 72px;width:72px;height:72px;background-size:contain;background-repeat:no-repeat;background-position:center;border-radius:8px}'
      + '.clovie-rec__info{display:flex;flex-direction:column;gap:5px;flex:1 1 auto;min-width:0}'
      + '.clovie-rec__title{font-size:.78rem;line-height:1.2;font-weight:600;color:#1a1a1a;text-decoration:none;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}'
      + '.clovie-rec__pricewrap{font-size:.8rem}'
      + '.clovie-rec__price{font-weight:700;color:#1a1a1a}'
      + '.clovie-rec__compare{color:#9a9a9a;text-decoration:line-through;font-size:.72rem;margin-left:5px}'
      + '.clovie-rec__controls{display:flex;gap:6px;align-items:center;margin-top:2px}'
      + '.clovie-rec__select{flex:1 1 auto;min-width:0;font-size:.68rem;padding:5px 6px;border:1px solid #ddd;border-radius:6px;background:#fff}'
      + '.clovie-rec__add{flex:0 0 auto;font-size:.72rem;font-weight:700;background:#1a1a1a;color:#fff;border:0;border-radius:6px;padding:8px 14px;cursor:pointer;line-height:1;white-space:nowrap}'
      + '.clovie-rec__controls .clovie-rec__add:only-child{flex:1 1 auto}'
      + '.clovie-rec__add:disabled{opacity:.65;cursor:default}';
    var s = document.createElement('style');
    s.id = 'clovie-recs-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init() {
    injectCss();
    render();
    document.addEventListener('on:cart:after-merge', render);
    document.addEventListener('on:cart-drawer:after-open', render);
    document.addEventListener('on:cart:add', render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
